import { ILoaiGioHoc } from "../../../model/respone/category/ILoaiGioHoc";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eLoaiGioHocActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as ILoaiGioHoc[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as ILoaiGioHoc | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as ILoaiGioHoc,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",
};

export const eLoaiGioHocActionIds = generateActionTypeIds(eLoaiGioHocActionsObj, "LOAI_GIO_HOC");
export type ILoaiGioHocActionTypes = IGenericActionType<typeof eLoaiGioHocActionsObj, "LOAI_GIO_HOC">;
